import React, { useState } from 'react'
import MainLayout from '../Layouts/MainLayout'
import OrderDetails from './ModelsImages'
import ModelsImages from './ModelsImages'

function ModelImageContainer() {
  return (
    <MainLayout navTitle={"Model Images"} navSubTitle={"Welcome to ImagesBazaar"}>
        <ModelsImages/>
    </MainLayout>
  )
}

export default ModelImageContainer

